var _path, _path2, _linearGradient, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _radialGradient, _path1, _path10, _path11, _linearGradient2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#633d35",
    d: "M37.29 113.26l-8.42 4.48V97.58l10.52 11.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.99 19.95c0 3.02.51 21.49.51 21.49s.26 1.98 1.75 2.48c.98.33 3.12-.37 5.73-2.41c.35-.27.82-.31 1.2-.09c1 .6 3.15 1.77 4.5 5.32c1.49 3.92 1.21 7.22.98 8.62c-.08.47-.3.9-.57 1.24c-2.43 3-14.59 18.58-14.59 28.48c0 0 .2 14.45.2 22.95c0 7.75-13.09 14.22-30.49 15.72l-9.71-2.67l-11.2 2.01c-3.56-.55-6.88-1.31-9.86-2.25l-7.47-21.02l-2.1 17.92s-5.61-5.75-5.61-9.71c0-8.57-2.1-88.03-2.1-88.03l78.83-.05z",
    fill: "#ad7156"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26057",
    gradientUnits: "userSpaceOnUse",
    x1: 102.035,
    y1: 43.768,
    x2: 102.017,
    y2: 43.832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce8963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d08a61",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.25 43.91z",
    fill: "url(#IconifyId17ecdb2904d178eab26057)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 35.58c-.33 5.56-.91 11.07-1.53 16.57l-.93 8.23c-.29 2.74-.67 5.45-.59 8.08c0 2.7.13 5.46.27 8.21l.37 8.28c.24 5.53.45 11.06.41 16.63c-1.2-5.44-2.05-10.93-2.74-16.44c-.68-5.52-1.21-11.02-1.31-16.67c-.02-2.91.4-5.71.78-8.46c.44-2.75.88-5.49 1.43-8.21c1.07-5.45 2.29-10.86 3.84-16.22z",
    fill: "#ce8963"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 63.58c.27.7.3 1.46.38 2.19c.05.74.1 1.48.12 2.22c.04 1.48.06 2.96.04 4.44c-.02 2.96-.13 5.91-.29 8.86c-.15 2.95-.35 5.89-.59 8.83c-.21 2.94-.52 5.88-.81 8.82l-.03-.36l1.42 5.21l1.35 5.23c.87 3.5 1.7 7 2.41 10.55c-1.32-3.36-2.52-6.77-3.68-10.18l-1.7-5.13L31 99.13l-.05-.16l.02-.19c.25-2.93.46-5.87.74-8.81c.25-2.93.53-5.87.82-8.8l.89-8.79l.43-4.4c.07-.73.13-1.47.18-2.2c.02-.73.12-1.47-.03-2.2z",
    fill: "#ce8963"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 96.08v25l8 2s-5-15-8-27z",
    fill: "#ce8963"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 79.08c5.68-12.95 25.68-26.93 25.68-26.93l.59-.43c.11 1.76.02 3.04-.14 3.74c-.07.31-.3.82-.46 1.01c-1.92 2.36-14.67 18.42-14.67 28.6c0 0 .2 14.45.2 22.95c0 3.81-4.2 9.05-13.2 12.05l4-29l-9 9c0 .01 3.01-11.88 7-20.99z",
    fill: "#965b44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 40.79c.26 4.05 3.08 3.13 3.08 3.13c-3.24 1.52-7.94 2.37-10.66.56c-3-2-4.42-12.39-4.42-12.39l2-6l9.44-5.53l.56 20.23z",
    fill: "#965b44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.48 4.27C38.43 4.73 22.5 11.73 22.5 20.3c0 8.87 17.05 16.05 38.08 16.05s38.08-7.19 38.08-16.05c0-8.53-15.78-15.51-35.71-16.02",
    fill: "#ffcc80"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.48 4.27c-7.17.57-14.32 1.7-20.99 4.16c-3.32 1.21-6.56 2.71-9.27 4.8c-1.33 1.05-2.56 2.23-3.37 3.59c-.84 1.34-1.18 2.84-.94 4.28c.24 1.43 1.05 2.79 2.16 3.95c1.11 1.16 2.45 2.19 3.91 3.05c2.93 1.73 6.22 2.96 9.58 3.89c6.75 1.86 13.83 2.64 20.89 2.63c7.05.02 14.14-.73 20.9-2.57c3.36-.92 6.67-2.13 9.61-3.83c1.47-.85 2.84-1.84 3.96-3c1.13-1.14 2-2.48 2.28-3.91c.33-1.43-.01-2.93-.77-4.29c-.78-1.36-1.97-2.57-3.29-3.63c-2.67-2.13-5.91-3.64-9.22-4.87c-6.65-2.49-13.8-3.64-20.97-4.24c1.8-.03 3.6-.02 5.41.04c1.8.09 3.61.24 5.4.45c3.59.44 7.18 1.09 10.69 2.13c3.49 1.08 6.95 2.47 10.05 4.66c1.55 1.1 2.99 2.44 4.07 4.16c1.07 1.71 1.68 3.93 1.29 6.06c-.34 2.14-1.5 3.97-2.82 5.42c-1.34 1.47-2.9 2.62-4.52 3.62c-3.24 1.98-6.74 3.33-10.28 4.39c-7.12 2.04-14.47 2.84-21.8 2.87c-7.32-.06-14.68-.87-21.79-2.95c-3.54-1.07-7.03-2.45-10.26-4.45c-1.61-1.01-3.15-2.2-4.48-3.69c-1.3-1.48-2.4-3.37-2.68-5.51c-.13-1.06-.06-2.15.21-3.18c.26-1.03.74-1.96 1.29-2.81c1.11-1.7 2.59-2.99 4.14-4.08C30 9.27 33.45 7.89 36.95 6.83c3.51-1.02 7.1-1.66 10.7-2.09c1.8-.2 3.6-.35 5.41-.43c1.81-.08 3.62-.08 5.42-.04z",
    fill: "#ce8963"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab26058",
    cx: 59.442,
    cy: 16.159,
    r: 21.667,
    gradientTransform: "matrix(-1.1788 0 0 .9412 130.18 -.789)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#ffa726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#ffa726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa726",
    stopOpacity: 0.1
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.91 17.65c0 7.03 14.33 12.73 32.02 12.73s32.02-5.7 32.02-12.73S79.7 2.51 53.93 4.91c-17.61 1.65-32.02 5.7-32.02 12.74z",
    fill: "url(#IconifyId17ecdb2904d178eab26058)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.08 18.62c-.01 1.39.81 2.64 1.79 3.61c1.01.96 2.21 1.71 3.46 2.34c2.51 1.24 5.22 2.04 7.95 2.66c5.48 1.15 11.1 1.56 16.68 1.49c5.58-.07 11.18-.63 16.57-1.95c2.68-.68 5.33-1.55 7.75-2.8c1.2-.62 2.33-1.38 3.26-2.26c.9-.9 1.57-1.98 1.54-3.08c-.01-1.09-.69-2.14-1.61-3.01c-.94-.86-2.07-1.58-3.28-2.17c-2.42-1.19-5.07-1.99-7.75-2.61c-2.69-.62-5.43-1.03-8.18-1.31c-2.75-.3-5.53-.44-8.3-.46c-5.55-.04-11.13.24-16.6 1.29c-2.72.56-5.43 1.28-7.95 2.46c-1.25.6-2.45 1.32-3.48 2.25c-.99.93-1.83 2.15-1.85 3.55zm-.22 0c-.02-1.48.83-2.79 1.83-3.79c1.03-1 2.21-1.82 3.47-2.49c2.5-1.37 5.19-2.34 7.93-3.11c5.48-1.52 11.18-2.27 16.87-2.33c2.85-.01 5.7.11 8.54.39c2.84.3 5.66.78 8.45 1.46c2.78.71 5.53 1.61 8.14 2.97c1.3.68 2.55 1.5 3.67 2.57c.54.55 1.05 1.17 1.44 1.89c.39.72.64 1.57.63 2.44c-.01.87-.27 1.71-.67 2.42s-.91 1.32-1.46 1.85c-1.12 1.04-2.38 1.83-3.69 2.47c-2.61 1.29-5.36 2.13-8.14 2.77c-5.56 1.25-11.24 1.71-16.9 1.67c-5.65-.1-11.32-.71-16.79-2.13c-2.73-.71-5.43-1.61-7.94-2.91c-1.26-.64-2.45-1.43-3.49-2.4c-1.01-.98-1.88-2.26-1.89-3.74z",
    fill: "#7f441c",
    opacity: 0.66
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.81 17.5c0 3.71 9.66 6.72 21.57 6.72s21.57-3.01 21.57-6.72s-9.66-6.72-21.57-6.72s-21.57 3.01-21.57 6.72zm3.68 0c0-2.78 7.62-5.04 17.03-5.04s17.03 2.26 17.03 5.04s-7.62 5.04-17.03 5.04s-17.03-2.26-17.03-5.04z",
    opacity: 0.82,
    fill: "#b5772c"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab26059",
    gradientUnits: "userSpaceOnUse",
    x1: 50.85,
    y1: 16.939,
    x2: 67.839,
    y2: 16.939,
    gradientTransform: "matrix(-1 0 0 1 120.75 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a5140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a5140"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.41,
    cy: 16.94,
    rx: 8.49,
    ry: 2.24,
    opacity: 0.74,
    fill: "url(#IconifyId17ecdb2904d178eab26059)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWood);
export default __webpack_public_path__ + "static/media/Wood.e0dd2def49d9d502a822bd7834005e8a.svg";
export { ForwardRef as ReactComponent };